module.exports = __webpack_public_path__ + "img/1.7e4de254.png";